/*Copyright © SITA INC Ireland, SITA INC USA, SITA Switzerland Sarl 2025. Confidential. All rights reserved.*/
import { ErrorHandler, Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Constants } from '../constants';
import { HttpErrorResponse } from '@angular/common/http';
import { LoadingService } from './loading.service';

@Injectable({
  providedIn: 'root'
})
export class GlobalErrorHandlerService implements ErrorHandler {

  constructor(private readonly snackBar: MatSnackBar, private readonly loader: LoadingService) { }

  handleError(error: any): void {
    this.loader.hideSpinner();
    let msg = error?.error?.message;

    if (error instanceof HttpErrorResponse) {
      msg = Constants.ERROR_MSG.Internal_Server_Error;
    }
    if(msg){
      this.snackBar.open(msg, 'Error',{
        duration: 3000,panelClass:['error-snackbar']
      });  
    }
  }
}
